import React, { useState } from 'react';
import { Button, TextField, Box, Typography, Container, Paper, CircularProgress, Alert } from '@mui/material';
import { useNavigate, Link } from 'react-router-dom';
import FetchService from '../../services/FetchService';
import endpoints from '../../environment/endpoints';
import { useAuth } from '../../context/AuthContext';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();
  const fetchService = new FetchService();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    const res = await fetchService.post(endpoints.login, { email, password });
    if (res.success && res.data?.token) {
      login(res.data.user, res.data.token);
      navigate('/mashlist/list');
    } else {
      setError(res.errors || 'Invalid login attempt.');
    }
    setIsLoading(false);
  };

  return (
    <Container maxWidth="sm">
      <Paper elevation={3} sx={{ padding: 4, marginTop: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Typography component="h1" variant="h4" gutterBottom fontWeight="bold" color="secondary">
          Welcome Back
        </Typography>
        <Typography variant="body1" color="textSecondary" sx={{ mb: 3 }}>
          Log in to manage your Mash Lists
        </Typography>

        {error && <Alert severity="error" sx={{ width: '100%', mb: 2 }}>{error}</Alert>}

        <Box component="form" onSubmit={handleLogin} sx={{ mt: 1, width: '100%' }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="secondary"
            disabled={isLoading}
            sx={{ mt: 3, mb: 2, padding: 1.5, fontSize: '1.1rem' }}
          >
            {isLoading ? <CircularProgress size={24} /> : 'Login'}
          </Button>
          
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
            <Typography variant="body2">
              <Link to="/forgot-password" style={{ color: '#666', textDecoration: 'underline' }}>
                Forgot your password?
              </Link>
            </Typography>
            <Typography variant="body2">
              Don't have an account?{' '}
              <Link to="/register" style={{ color: '#FF3900', textDecoration: 'none', fontWeight: 'bold' }}>
                Sign Up
              </Link>
            </Typography>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
}
